import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/img/bussinessimg.png'


const _hoisted_1 = { class: "organizationdetail" }
const _hoisted_2 = { class: "bussinessname flex-n fac fjb" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "label label-color1"
}
const _hoisted_5 = {
  key: 1,
  class: "label label-color2"
}
const _hoisted_6 = {
  key: 2,
  class: "label label-color3"
}
const _hoisted_7 = { style: {"font-size":"1.4rem","padding-bottom":"1rem"} }

import {onMounted,ref} from "vue";
import ZCard from "@/components/ZCard/ZCard.vue";
import ZCell from "@/components/ZCell/ZCell.vue";
import {useRoute} from 'vue-router'
import organizationApi from "@/utils/Api/Organization";

export default /*@__PURE__*/_defineComponent({
  __name: 'organizationdetail',
  setup(__props) {


onMounted(()=>{
  document.title='机构详情';
  getData();
})
const route=useRoute();
const info=ref({});
const getData=()=>{
  organizationApi.detail(route.query.id).then(res=>{
    console.log(res)
    info.value=res.data;
  })
}
const onClickLeft=()=>{
  history.back();
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "机构详情",
      "left-arrow": "",
      onClickLeft: onClickLeft
    }),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "banner",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(info.value.companyName), 1),
      (info.value.merchantCategory==2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "殡仪公司"))
        : _createCommentVNode("", true),
      (info.value.merchantCategory==3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "墓园企业"))
        : _createCommentVNode("", true),
      (info.value.merchantCategory==4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "殡仪馆"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ZCard, {
      class: "mt-20",
      title: "企业信息"
    }, {
      default: _withCtx(() => [
        _createVNode(ZCell, {
          "hidden-arrow": "",
          label: "法人姓名"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.contactName), 1)
          ]),
          _: 1
        }),
        _createVNode(ZCell, {
          "hidden-arrow": "",
          label: "成立时间"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.incorporationTime), 1)
          ]),
          _: 1
        }),
        _createVNode(ZCell, {
          "hidden-arrow": "",
          label: "职工人数"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(info.value.employeeTotal) + "人", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ZCard, {
      class: "mt-20",
      title: "服务详情"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, _toDisplayString(info.value.companyDesc), 1)
      ]),
      _: 1
    })
  ]))
}
}

})